export default <(...args: any[]) => any>(() => {});
